"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var type_utils_1 = require("./type-utils");
function clone(obj) {
    if (obj == null || typeof (obj) !== 'object') {
        return obj;
    }
    var temp = null;
    if (type_utils_1.isDate(obj)) {
        temp = new Date(obj.getTime());
    }
    else {
        temp = obj.constructor();
        for (var key in obj) {
            temp[key] = clone(obj[key]);
        }
    }
    return temp;
}
exports.default = clone;
//# sourceMappingURL=clone.js.map